module.exports = (__parcel__import__("IAr4D")).then(() => parcelRequire('kRw5D'));